import { useNotifications } from '../../context/NotificationContext';

export const useIncidentNotifications = () => {
  const { addNotification, showNotification } = useNotifications();

  const notifyNewIncident = (incident, createdBy) => {
    const priorityMap = {
      low: 'info',
      medium: 'medium', 
      high: 'high',
      critical: 'critical'
    };

    addNotification({
      type: 'incident_created',
      priority: priorityMap[incident.priority] || 'medium',
      title: '🆕 Новий інцидент',
      message: `Тип: ${incident.type} | Клієнт: ${incident.clientName || 'N/A'} | Пріоритет: ${incident.priority}`,
      data: incident,
      category: 'incidents',
      actions: ['view', 'respond'],
      targetUrl: `/incidents/${incident.id}`
    });
  };

  const notifyIncidentResponse = (incident, response, responder) => {
    addNotification({
      type: 'incident_response',
      priority: 'medium',
      title: '💬 Нова відповідь на інцидент',
      message: `${responder.name} додав(ла) відповідь: ${response.message.substring(0, 100)}...`,
      data: { incident, response },
      category: 'incidents',
      actions: ['view'],
      targetUrl: `/incidents/${incident.id}`
    });
  };

  const notifyIncidentEscalation = (incident, escalationType) => {
    const escalationMessages = {
      critical_auto_escalation: {
        title: '🚨 Автоматична ескалація',
        message: `Критичний інцидент потребує уваги!`
      },
      time_based_escalation: {
        title: '⏰ Ескалація через час',
        message: `Інцидент в роботі більше 24 годин`
      },
      response_time_escalation: {
        title: '📨 Відсутність відповідей',
        message: `Пріоритет підвищено через відсутність відповідей`
      }
    };

    const message = escalationMessages[escalationType];
    if (message) {
      addNotification({
        type: 'incident_escalation',
        priority: 'high',
        title: message.title,
        message: message.message,
        data: incident,
        category: 'incidents_escalation',
        actions: ['view', 'respond'],
        targetUrl: `/incidents/${incident.id}`
      });
    }
  };

  const notifyRecurringPattern = (pattern) => {
    addNotification({
      type: 'recurring_pattern',
      priority: pattern.severity === 'high' ? 'high' : 'medium',
      title: '🔄 Повторюваний патерн виявлено',
      message: `${pattern.pattern} - ${pattern.count} випадків`,
      data: pattern,
      category: 'incidents_analytics',
      actions: ['analyze', 'view_all'],
      targetUrl: '/incidents/analytics'
    });
  };

  return {
    notifyNewIncident,
    notifyIncidentResponse,
    notifyIncidentEscalation,
    notifyRecurringPattern
  };
};